import { Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { Subject, Observable, of, concat } from 'rxjs';
import { Store, select } from '@ngrx/store';
import * as fromUserProfile from 'src/app/modules/core/store/user-profile';
import { map, take, takeUntil, withLatestFrom } from 'rxjs/operators';
import { UserProfile, UserProfileApiService } from 'src/app/modules/core/store/user-profile';
import { Organization } from '@app/modules/core/store/models/organization.model';
import * as fromAuth from '../../store/auth';
import { AuthToken, UserContext } from '../../store/auth';
import produce from 'immer';
import { AuthApiService } from '../../store/auth/auth-api.service';
import { AcceptancePolicy } from '@app/modules/management/store/organizations';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'topo-business-units-warning',
    templateUrl: './business-units-warning.component.html',
    styleUrls: ['./business-units-warning.component.scss'],
    standalone: false
})
export class BusinessUnitsWarningComponent implements OnInit, OnDestroy {
  @Input() messageAlign: string = 'left';
  showPage: boolean;
  userContext: UserContext;
  icon: string = 'icon-small_solid_warning';
  private destroy$ = new Subject<void>();

  constructor(private store: Store<any>, private translateService: TranslateService) {}

  ngOnInit(): void {
    this.store
      .select(fromAuth.selectShowBusinessUnitsWarning)
      .pipe(
        takeUntil(this.destroy$),
        map(showPage => {
          this.showPage = showPage;
        })
      )
      .subscribe();

      this.store
      .select(fromAuth.selectUserContext)
      .pipe(
        takeUntil(this.destroy$),
        map(userContext => {
          this.userContext = userContext;
        })
      )
      .subscribe();

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  okClick(): void {
    this.store.dispatch(fromAuth.setBusinessUnitsWarningAccepted());
    this.showPage = false;
    this.store.dispatch(fromAuth.routeAfterLoginSuccess({ userContext: this.userContext, checkPolicy: false }));
  }
}
